// A map of user locales supported by CodeAI to locales provided by Blockly.
// For more information, see: https://github.com/RaspberryPiFoundation/blockly/tree/master/msg/json
export const blocklyLocaleMap = {
  'ar-sa': require('blockly/msg/ar'),
  'az-az': require('blockly/msg/az'),
  'bg-bg': require('blockly/msg/bg'),
  'bs-ba': require('blockly/msg/bs'),
  'ca-es': require('blockly/msg/ca'),
  'cs-cz': require('blockly/msg/cs'),
  'da-dk': require('blockly/msg/da'),
  'de-de': require('blockly/msg/de'),
  'el-gr': require('blockly/msg/el'),
  'en-us': require('blockly/msg/en'),
  'es-es': require('blockly/msg/es'),
  'es-mx': require('blockly/msg/es'),
  'et-ee': require('blockly/msg/et'),
  'eu-es': require('blockly/msg/eu'),
  'fa-ir': require('blockly/msg/fa'),
  'fi-fi': require('blockly/msg/fi'),
  'fil-ph': require('blockly/msg/en'), // English provided as broader alternative for Filipino
  'fr-fr': require('blockly/msg/fr'),
  'ga-ie': require('blockly/msg/en'), // English provided as broader alternative for Irish (Gaelic)
  'gl-es': require('blockly/msg/gl'),
  'he-il': require('blockly/msg/he'),
  'hi-in': require('blockly/msg/hi'),
  'hr-hr': require('blockly/msg/hr'),
  'hu-hu': require('blockly/msg/hu'),
  'hy-am': require('blockly/msg/hy'),
  'id-id': require('blockly/msg/id'),
  'is-is': require('blockly/msg/is'),
  'it-it': require('blockly/msg/it'),
  'ja-jp': require('blockly/msg/ja'),
  'ka-ge': require('blockly/msg/ka'),
  'ko-kr': require('blockly/msg/ko'),
  'kk-kz': require('blockly/msg/ru'), // Russian provided as regional alternative for Kazakh
  'km-kh': require('blockly/msg/km'),
  'ky-kg': require('blockly/msg/ky'),
  'lt-lt': require('blockly/msg/lt'),
  'lv-lv': require('blockly/msg/lv'),
  'mi-nz': require('blockly/msg/en'), // English provided as broader alternative for Maori
  'mn-nn': require('blockly/msg/ru'), // Russian provided as regional alternative for Mongolian
  'mr-in': require('blockly/msg/hi'), // Hindi provided as regional alternative for Marathi
  'my-mm': require('blockly/msg/my'),
  'nl-nl': require('blockly/msg/nl'),
  'nn-no': require('blockly/msg/nb'), // Norwegian Bokmål provided as alternative written standard for Norwegian Nynorsk
  'no-no': require('blockly/msg/nb'),
  'pl-pl': require('blockly/msg/pl'),
  'pt-br': require('blockly/msg/pt-br'),
  'pt-pt': require('blockly/msg/pt'),
  'ro-ro': require('blockly/msg/ro'),
  'ru-ru': require('blockly/msg/ru'),
  'se-fi': require('blockly/msg/nb'), // Norwegian Bokmål provided as regional alternative for Northern Sami
  'si-lk': require('blockly/msg/si'),
  'sk-sk': require('blockly/msg/sk'),
  'sl-si': require('blockly/msg/sl'),
  'sm-ws': require('blockly/msg/en'), // English provided as broader alternative for Samoan
  'sq-al': require('blockly/msg/sq'),
  'sr-sp': require('blockly/msg/sr'),
  'sv-se': require('blockly/msg/sv'),
  'ta-in': require('blockly/msg/ta'),
  'te-in': require('blockly/msg/te'),
  'th-th': require('blockly/msg/th'),
  'tr-tr': require('blockly/msg/tr'),
  'uk-ua': require('blockly/msg/uk'),
  'uz-uz': require('blockly/msg/uz'),
  'vi-vn': require('blockly/msg/vi'),
  'zh-cn': require('blockly/msg/zh-hans'),
  'zh-tw': require('blockly/msg/zh-hant'),
};
